import { render, staticRenderFns } from "./PlacementResultModal.vue?vue&type=template&id=5b5320b0&scoped=true"
import script from "./PlacementResultModal.vue?vue&type=script&lang=js"
export * from "./PlacementResultModal.vue?vue&type=script&lang=js"
import style0 from "./PlacementResultModal.vue?vue&type=style&index=0&id=5b5320b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5320b0",
  null
  
)

export default component.exports